import Footer from './components/Footer';
import React, { useState, useCallback, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate,useLocation } from 'react-router-dom';
// import Navbar from './components/Navbar';
import axios from 'axios';
// import AddProduct from './components/AddProduct';
import ProductList from './components/ProductList';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import './App.css';
import { CartProvider, useCart } from './components/CartContext';
import Cart from './components/Cart';
import { FaShoppingCart } from 'react-icons/fa';
import Checkout from './components/Checkout';
import OrderSuccess from './components/OrderSuccess';
import OrderList from './components/OrderList';
import OrderDetails from './components/OrderDetails';
import api from './api';

import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import RefundPolicy from './components/RefundPolicy';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import DeliveryPolicy from './components/DeliveryPolicy';
import CookiePolicy from './components/CookiePolicy';
import DeliveryAgentDashboard from './components/DeliveryAgentDashboard';
import PasswordResetRequest from './utils/PasswordResetRequest';
import PasswordResetConfirm from './utils/PasswordResetConfirm';
import ProtectedCustomerRoute from './components/ProtectedCustomerRoute';

function AppContent({ 
  currentUser, 
  setCurrentUser, 
  csrfToken, 
  authChecked, 
  selectedCategory, 
  setSelectedCategory 
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { cart } = useCart();

  const isDeliveryAgent = currentUser?.groups?.includes('Delivery Agents') || 
                      currentUser?.is_delivery_agent || 
                      false;
  
  // Extra protection layer - catches any missed routes
  useEffect(() => {
    if (authChecked && isDeliveryAgent) {
      const customerOnlyRoutes = ['/cart', '/checkout', '/orders', '/order-success'];
      const isCustomerRoute = customerOnlyRoutes.some(route => 
        location.pathname.startsWith(route)
      );
      
      if (isCustomerRoute) {
        navigate('/delivery-dashboard', { replace: true });
      }
    }
  }, [authChecked, isDeliveryAgent, location.pathname, navigate]);

  const handleLogout = useCallback(async () => {
    if (!window.confirm('Are you sure you want to logout?')) return;
    
    try {
      await api.post('/api/token/logout/', {}, {
        withCredentials: true,
        headers: {
          'X-CSRFToken': csrfToken,
          'Content-Type': 'application/json'
        }
      });

      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      setCurrentUser(null);
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      localStorage.clear();
      setCurrentUser(null);
      navigate('/login');
    }
  }, [navigate, setCurrentUser, csrfToken]);

  const handleCategoryChange = useCallback((event) => {
    setSelectedCategory(event.target.value);
  }, [setSelectedCategory]);

  if (!authChecked) {
    return <div className="loading-screen">Loading...</div>;
  }

  return (
    <>
      <div className="header">
        <div className="logo-container">
          <h1>RurDel</h1>
          <p>Reaching Roots ⭐</p>
        </div>
        <div className="login-button-container">
          <Link 
            to="/cart" 
            className="cart-link"
            style={{
              textDecoration: 'none',
              color: 'inherit',
              marginRight: '15px',
              display: 'flex',
              alignItems: 'center',
              gap: '5px'
            }}
          >
            <FaShoppingCart style={{ fontSize: '1.2rem' }} />
            <span>Cart ({cart.length})</span>
          </Link>
          {/* ADD MY ORDERS LINK HERE */}
    {currentUser && (
      <Link 
        to="/orders" 
        style={{
          textDecoration: 'none',
          color: 'inherit',
          marginRight: '15px'
        }}
      >
        My Orders
      </Link>
    )}
          {currentUser ? (
            <button 
              onClick={handleLogout}
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                cursor: 'pointer',
                font: 'inherit',
                padding: 0,
                textDecoration: 'none'
              }}
            >
              Logout
            </button>
          ) : (
            <div style={{ display: 'flex', gap: '1rem' }}>
              <Link 
                to="/login" 
                style={{
                  textDecoration: 'none',
                  color: 'inherit'
                }}
              >
                Login
              </Link>
              <Link 
                to="/signup" 
                style={{
                  textDecoration: 'none',
                  color: 'inherit'
                }}
              >
                Sign Up
              </Link>
            </div>
          )}
        </div>
      </div>
      

      <div className="content-area">
        <Routes>
  {/* Home Page - Protected from agents */}
  <Route path="/" element={
    <ProtectedCustomerRoute currentUser={currentUser}>
      <>
        <div className="filter-container">
          <label>Search by Category: </label>
          <select 
            value={selectedCategory} 
            onChange={handleCategoryChange}
          >
            <option value="All">All</option>
            <option value="Grocery">Grocery</option>
            <option value="vegetable">Vegetable</option>
            <option value="fruits">Fruit</option>
            <option value="Food">Food</option>
          </select>
        </div>
        <ProductList selectedCategory={selectedCategory} />
      </>
    </ProtectedCustomerRoute>
  } />
  
  {/* Login - No protection needed */}
  <Route path="/login" element={
    <LoginPage 
      onLoginSuccess={(userData) => {
        setCurrentUser(userData);
      }} 
    />
  } />
  
  {/* Agent Dashboard - No protection needed */}
  <Route path="/delivery-dashboard" element={<DeliveryAgentDashboard />} />
  
  {/* Signup - No protection needed */}
  <Route path="/signup" element={<SignupPage csrfToken={csrfToken} />} />
  
  {/* Cart - Protected from agents */}
  <Route path="/cart" element={
    <ProtectedCustomerRoute currentUser={currentUser}>
      <Cart />
    </ProtectedCustomerRoute>
  } />
  
  {/* Checkout - Protected from agents */}
  <Route path="/checkout" element={
    <ProtectedCustomerRoute currentUser={currentUser}>
      <Checkout currentUser={currentUser} csrfToken={csrfToken} />
    </ProtectedCustomerRoute>
  } />
  
  {/* Order Success - Protected from agents */}
  <Route path="/order-success" element={
    <ProtectedCustomerRoute currentUser={currentUser}>
      <OrderSuccess />
    </ProtectedCustomerRoute>
  } />
  
  {/* Orders List - Protected from agents */}
  <Route path="/orders" element={
    <ProtectedCustomerRoute currentUser={currentUser}>
      <OrderList />
    </ProtectedCustomerRoute>
  } />
  
  {/* Order Details - Protected from agents */}
  <Route path="/orders/:orderId" element={
    <ProtectedCustomerRoute currentUser={currentUser}>
      <OrderDetails />
    </ProtectedCustomerRoute>
  } />
  
  {/* Public Pages - No protection needed (agents can access these) */}
  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
  <Route path="/terms-conditions" element={<TermsConditions />} />
  <Route path="/refund-policy" element={<RefundPolicy />} />
  <Route path="/about-us" element={<AboutUs />} />
  <Route path="/contact-us" element={<ContactUs />} />
  <Route path="/delivery-policy" element={<DeliveryPolicy />} />
  <Route path="/cookie-policy" element={<CookiePolicy />} />
  <Route path="/password-reset" element={<PasswordResetRequest />} />
  <Route path="/password-reset-confirm/:uidb64/:token" element={<PasswordResetConfirm />} />
</Routes>
      </div>
      {/* Footer */}
      <Footer />
    </>
    
  );
}

function App() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [currentUser, setCurrentUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [csrfToken] = useState(''); //, setCsrfToken if required move alongside const[csrfToken]

  // // Get CSRF token on mount
  // useEffect(() => {
  //   const getCsrfToken = async () => {
  //     try {
  //       await axios.get('http://localhost:8000/api/get-csrf/', {
  //         withCredentials: true
  //       });
  //       const token = document.cookie.split('; ')
  //         .find(row => row.startsWith('csrftoken='))
  //         ?.split('=')[1] || '';
  //       setCsrfToken(token);
  //     } catch (error) {
  //       console.error('Error getting CSRF token:', error);
  //     }
  //   };
  //   getCsrfToken();
  // }, []);

  // Axios interceptors for token management
  useEffect(() => {
    const requestInterceptor = axios.interceptors.request.use(config => {
      const token = localStorage.getItem('access_token');
      if (token) config.headers.Authorization = `Bearer ${token}`;
      if (csrfToken) config.headers['X-CSRFToken'] = csrfToken;
      return config;
    });

    const responseInterceptor = axios.interceptors.response.use(
      response => response,
      async error => {
        const originalRequest = error.config;
        
        if (error.response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          
          try {
            const refreshToken = localStorage.getItem('refresh_token');
            if (!refreshToken) throw new Error('No refresh token');
            
            const { data } = await axios.post('/api/token/refresh/', 
              { refresh: refreshToken },
              { withCredentials: true }
            );
            
            localStorage.setItem('access_token', data.access);
            originalRequest.headers.Authorization = `Bearer ${data.access}`;
            return axios(originalRequest);
          } catch (err) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            setCurrentUser(null);
            return Promise.reject(err);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [csrfToken]);

  // Single auth check on mount
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          setAuthChecked(true);
          return;
        }

        const { data } = await api.get('/api/user/');
        setCurrentUser(data);
      } catch (error) {
        console.error("Auth check failed:", error);
        localStorage.removeItem('access_token');
        setCurrentUser(null);
      } finally {
        setAuthChecked(true);
      }
    };

    checkAuth();
  }, []);

  return (
    <div className="App">
      <AppContent
        currentUser={currentUser}
        setCurrentUser={setCurrentUser}
        csrfToken={csrfToken}
        authChecked={authChecked}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <CartProvider>
        <App />
      </CartProvider>
    </Router>
  );
}

export default AppWrapper;